import { render, staticRenderFns } from "./DataSingleViewComponent.vue?vue&type=template&id=a002c8ac&"
import script from "./DataSingleViewComponent.vue?vue&type=script&lang=js&"
export * from "./DataSingleViewComponent.vue?vue&type=script&lang=js&"
import style0 from "./DataSingleViewComponent.vue?vue&type=style&index=0&id=a002c8ac&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports